import { TIMESHEET_KEYS } from '../../enums/timesheet.enum';
import { BARCODE_CLIPBOARD_CONCURRENT_STORAGE_KEY } from '../barcode-scanner/barcode-scanner.const';

/**
 * Keys of the storage services that have no NgRx slice yet and still write the concurrency store
 * directly, even with `enableNgRx` on. `ConcurrentUsageService` moves only known keys between
 * devices, so these must be listed here to be part of the device handover. Each service reads its
 * key from here, so the name cannot drift away from this list. Remove a key once its service is
 * migrated to a persisted slice.
 */
export const LEGACY_CONCURRENT_USAGE_KEYS = {
    material: 'MATERIAL-material',
    materialOrder: 'MATERIAL-order',
    smartlocker: 'smartlocker',
    physicalInventorySchedule: 'piScheduleStatus',
    physicalInventory: 'physicalInventory',
    otherTasksOriginalDates: 'OTHER_TASKS_ORIGINAL_DATES',
} as const;

/** The recently-completed list the legacy `StorageNotificationStatusService` writes. */
export const KEY_NOTIFICATION_COMPLETED = 'notificationRecentlyCompleted';

/**
 * DEPRECATED — delete this list once no device has legacy data left to migrate.
 *
 * Keys that only the legacy (non-NgRx) services write. With NgRx on, nothing writes them any more;
 * they are still downloaded on check-in only so that `LegacyDataMigrationService` and
 * `BarcodeClipboardEffects` can move data that another device left behind into the NgRx slices.
 * The per-notification confirmation keys (`CONFIRMATION-*`) cannot be listed here, because their
 * names are not known in advance — so legacy confirmations are only migrated on the device that
 * wrote them.
 */
export const DEPRECATED_MIGRATION_CONCURRENT_USAGE_KEYS: readonly string[] = [
    TIMESHEET_KEYS.CURRENT_TIMESHEET,
    TIMESHEET_KEYS.SUBMITTED_TIMESHEET,
    KEY_NOTIFICATION_COMPLETED,
    BARCODE_CLIPBOARD_CONCURRENT_STORAGE_KEY,
];
